export const kindLabel = (kind, texts)=>{
    switch(kind){
        case 'stale_price':
            return texts.stalePrice();
        case 'recurring_adhoc':
            return texts.recurringAdhoc();
        case 'cross_sell':
            return texts.crossSell();
        case 'discount_leak':
            return texts.discountLeak();
    }
};
export const actionLabel = (kind, texts)=>{
    switch(kind){
        case 'stale_price':
            return texts.stalePrice();
        case 'recurring_adhoc':
            return texts.recurringAdhoc();
        case 'cross_sell':
            return texts.crossSell();
        case 'discount_leak':
            return texts.discountLeak();
    }
};
export const confidenceLabel = (band, texts)=>{
    switch(band){
        case 'high':
            return texts.high();
        case 'medium':
            return texts.medium();
        case 'low':
            return texts.low();
    }
};
